<rsm-pix-payment-display
  [paymentMethod]="paymentMethod"
  [qrCode]="paymentReference"
  [isGenerating]="isGeneratingPix"
  [isGeneratingBoleto]="isGeneratingBoleto"
  [generated]="pixGenerated"
  [confirmed]="pixConfirmed"
  [checking]="pollingActive"
  [timedOut]="pollingTimedOut"
  [amount]="amount"
  [dueDate]="dueDate"
  [boletoDescription]="boletoDescription"
  [boletoDescriptionDetail]="boletoDescriptionDetail"
  [boletoInfoLine]="boletoInfoLine"
  (methodChange)="selectPaymentMethod($event)"
  (generate)="generatePix()"
  (generateBoleto)="generateBoleto()"
  (downloadBoleto)="downloadBoleto()"
  (retry)="retryPix()"
  (copy)="copyCode()"
></rsm-pix-payment-display>
